import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DeclineComponent } from 'src/app/Components/excutor-decline/decline.component';
import { FamilyInviationService } from 'src/app/Service/familyinviation.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { LoggingService } from 'src/app/Service/logging.service';

@Component({
    selector: 'executor-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['../../Executor/executor.component.css'],
    styles: ['.content_wrapper{background-color: #F8FAFC;}'],
    standalone: false
})
export class WelcomeComponent {
  subscription = new Subscription();
  invitationId = null;
  password = '';
  confirmPwd = '';
  isPassWordType = true;
  isConfirmPassWordType = true;
  isCheck: boolean = false;
  isErrorState: boolean = false;
  passwordPolicy: any;
  constructor(
    private dialog: NgbModal,
    public loaderService: LoadingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public familyInviationService: FamilyInviationService,
    private logging: LoggingService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      if (params) {
        this.familyInviationService.GetExecutorExistsStatus(params['id']);
        this.invitationId = params['id'];
      } else this.router.navigateByUrl('');
    });
    this.loaderService.HideLoading();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  DeclineInvitation() {
    const dialogRef = this.dialog.open(DeclineComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    dialogRef.closed.toPromise().then((resp) => {
      if (resp) {
        this.familyInviationService.DeclineInvitation(this.invitationId);
      }
    });
  }
  AcceptInvitation() {
    if (this.password === this.confirmPwd) {
      this.isErrorState = false;
      if (
        (this.password ||
          this.familyInviationService.executorInvitationDetails.isExist) &&
        this.invitationId
      ) {
        this.subscription.add(
          this.familyInviationService.AcceptInvitation(
            this.invitationId,
            this.password
          )
        );
      }
    } else {
      this.isErrorState = true;
    }
  }
  public checkPassword() {
    const pass = this.password;
    this.passwordPolicy = {
      hasCapital: pass.match('.*[A-Z].*'),
      hasLower: pass.match('.*[a-z].*'),
      hasNumber: pass.match('.*\\d.*'),
      hasLength: pass.length >= 8,
      hasSpecial: pass.match(/[!"#$%&'()*+.\/:;<=>?@\[\\\]^_`{|}~-]/),
    };
  }
}
